import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { STORE_TYPE } from 'ggApp/modules/store/constants';

import {
    isLoggedIn as isLoggedInSelector,
    user as userSelector,
} from 'ggApp/modules/auth/selectors';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import { businessStoreDealsFlag } from 'ggApp/modules/featureFlag/selectors';

import PageList from './PageList';

const enhance = compose(
    connect(
        createStructuredSelector({
            activeStore: activeStoreSelector,
            isLoggedIn: isLoggedInSelector,
            businessStoreDealsEnabled: businessStoreDealsFlag,
            user: userSelector,
        }),
    ),
    withProps(({ activeStore: { code } }) => ({
        isBusinessStore: code === STORE_TYPE.BUSINESS,
    })),
);

export default enhance(PageList);
